import { useDisclosure } from '@crehana/react-hooks';

import { useUpdateUserTour } from '@/shared/hooks';
import { UserTourSectionEnum } from '@/shared/types/graphql/globals';

/**
 * Hook para controlar el tour de cursos guardados
 */
const useSavedCoursesTourQuery = () => {
  const { skipTour, completeTour } = useUpdateUserTour();
  const { isOpen, onOpen, onClose } = useDisclosure(false);

  const onSkip = () => {
    skipTour({ section: UserTourSectionEnum.USER_DASHBOARD_SAVED_COURSES });
    onClose();
  };

  const onComplete = () => {
    completeTour({ section: UserTourSectionEnum.USER_DASHBOARD_SAVED_COURSES });
    onClose();
  };

  return { onComplete, onSkip, isOpen, onOpen, onClose };
};

export default useSavedCoursesTourQuery;
